export const ITINERAIRES_LIST = [
  { code: 'CONAKRY', nom: 'Conakry' },
  { code: 'DAKAR', nom: 'Dakar' },
  { code: 'BAMAKO', nom: 'Bamako' },
  { code: 'BANJUL', nom: 'Banjul' },
  { code: 'LABE', nom: 'Labé' },
];


export const getNomItineraire = (code: string): string => {
  const itineraire = ITINERAIRES_LIST.find(i => i.code === code);
  return itineraire ? itineraire.nom : code;
};